import type { ProblemDetails } from "../../shared/types/problem-details.type";

export const getProblemDetailsErrorMessage = (
  error: ProblemDetails,
  fallbackMessage: string
): string => {
  if (error?.type === "UnknownApiError") {
    return fallbackMessage;
  }

  const rootDetail = error?.detail;
  if (typeof rootDetail === "string" && rootDetail.length > 0) {
    return rootDetail;
  }

  const nestedDetail = error?.details?.detail;
  if (typeof nestedDetail === "string" && nestedDetail.length > 0) {
    return nestedDetail;
  }

  if (typeof error?.message === "string" && error.message.length > 0) {
    return error.message;
  }

  return fallbackMessage;
};
